export const fontBackgroundColorPlugin = {
  isLeaf: true,
};
